import { useMutation } from "react-query";
import { addEmailDomain } from "../../../../../actions/Utilities/EmailDomain";
import { toast } from "components/toastNotification";
import { IEmailDomain } from "../types";
import { useRecoilState, useSetRecoilState } from "recoil";
import {
  addStateEmailDomain,
  emailDomainReFetching,
} from "../atoms/atoms";

const useAddEmailDomain = () => {
  const setIsAddState = useSetRecoilState(addStateEmailDomain);
  const [isReFetching, setIsReFetching] = useRecoilState(
    emailDomainReFetching
  );

  const { mutate } = useMutation(
    (NewData: IEmailDomain) => addEmailDomain(NewData),
    {
      onSuccess: (res: any) => {
        if (typeof res == "object") {
          toast.fire("Adding Email Domain failed", res.Message, "error");
        } else {
          switch (true) {
            case res == "Success":
              toast.fire(
                "Success",
                "Email Domain Added Successfully",
                "success"
              );
              break;
            case res.includes("Notification insert Failed"):
              toast.fire(
                "Success ",
                `Email Domain Added Successfully, BUT ${res}`,
                "warning"
              );
              break;
            case res == "Operation Failed!":
              toast.fire(
                "Adding Email Domain failed ",
                `Server Error: ${res}`,
                "error"
              );
              break;
            case res == "The data already exists!":
              toast.fire(
                "Adding Email Domain failed",
                `Duplication Error: ${res}`,
                "error"
              );
              break;
            default:
              toast.fire("Adding Email Domain failed", res, "error");
          }
        }

        // Redirect to View
        setIsAddState(false);

        // ReFetch Data
        setIsReFetching(isReFetching ? false : true);
      },

      onError: (error: any) => {
        toast.fire("Add Email Domain failed", `Error: ${error}`, "error");
      },
    }
  );

  return mutate;
};
export default useAddEmailDomain;
